module.exports = __webpack_public_path__ + "img/L_317_0.43403141.png";